<div [ngClass]="{'is-last': isLastNews()}"
     [class.no-left-margin]="noLeftMargin()"
     class="news-wrapper">
  <app-tag-section
    [customDateField]="customDateField()"
    [news]="news()" [withBMargin]="false"></app-tag-section>
  <a [href]="HELPER.getUrl(news().sourceUrl)" target="{{newTabLink() ? '_blank' : '_self' }}">

    <div class="news-title">
      @if (showShortTitle()) {
        {{ news().shortTitle || news().title }}
      } @else {
        {{ news().title }}
      }
    </div>

  </a>
  <div [innerHTML]="news().summary || news().htmlDescription | removeHtml"
       class="news-description"></div>
</div>
